import React, { Component } from "react";
// import IconeFleche from "../img/fleche-blanche.png";
import LogoFacebook from "../img/facebook.png";
import LogoInsta from "../img/insta.png";
import Spinner from "./Spinner";
import moment from "moment";
moment.locale("fr", {
  months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
    "_"
  ),
  monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
    "_"
  ),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  },
  calendar: {
    sameDay: "[Aujourd’hui à] LT",
    nextDay: "[Demain à] LT",
    nextWeek: "dddd [à] LT",
    lastDay: "[Hier à] LT",
    lastWeek: "dddd [dernier à] LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function(number) {
    return number + (number === 1 ? "er" : "e");
  },
  meridiemParse: /PD|MD/,
  isPM: function(input) {
    return input.charAt(0) === "M";
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function(hours, minutes, isLower) {
    return hours < 12 ? "PD" : "MD";
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});

class AmbassadriceContent extends Component {
  state = {};

  checkDate = date => {
    const dateAtelier = new moment(date, "M-D-YYYY");
    const today = new moment();
    return dateAtelier.isAfter(today, "day");
  };

  render() {
    if (!this.props.data || this.props.data.length === 0) {
      return (
        <div className="content">
          <Spinner />
        </div>
      );
    } else {
      const nom = this.props.data.name;
      const ville = this.props.data.acf.ambassadrice_ville;
      const description = this.props.data.description;
      const photo = this.props.data.acf.ambassadrice_photo;
      const site = this.props.data.url;
      const citation = this.props.data.acf.ambassadrice_citation;
      const facebook = this.props.data.acf.ambassadrice_facebook;
      const insta = this.props.data.acf.ambassadrice_insta;
      const telephone = this.props.data.acf.ambassadrice_telephone;
      const email = this.props.data.user_email;
      const atlDispos = this.props.data.acf.ambassadrice_atl_dispo;

      return (
        <div className="content">
          <section className="ambassadrice_detail">
            <article>
              <div className="col3 wow fadeInDown detail">
                <a
                  onClick={this.props.showMap}
                  className="goback blanc"
                  //href="#"
                >
                  {/* <img
                    src={IconeFleche}
                    style={{ paddingRight: "0.3rem", paddingTop: "0.2rem" }}
                    alt=""
                  /> */}
                  <span
                    // className="underline blanc"
                    style={{
                      backgroundColor: "#d31554",
                      padding: "10px 15px",
                      fontWeight: "700"
                    }}
                  >
                    Retour à la carte
                  </span>
                </a>
                <div>
                  <img className="ambassadrice_photo" src={photo} alt="" />
                  <p>Contactez-moi !</p>
                  <a className="btn bleu_f mail" href={"mailto:" + email}>
                    envoyez un email
                  </a>
                  {telephone && (
                    <a className="tel" href={"tel:" + telephone}>
                      Tél. : {telephone}
                    </a>
                  )}
                  <div className="ambassadrice_liens">
                    {insta && (
                      <a href={insta} target="blank">
                        <img src={LogoInsta} alt="" />
                      </a>
                    )}
                    {facebook && (
                      <a href={facebook} target="blank">
                        <img src={LogoFacebook} alt="" />
                      </a>
                    )}
                    {site && (
                      <a
                        className="website underline blanc"
                        href={site}
                        target="blank"
                      >
                        Site internet
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="col3 wow fadeInDown" data-wow-delay="0.2s">
                <h1>{nom}</h1>
                <p
                  style={{
                    marginBottom: "20px",
                    marginTop: "-10px",
                    fontStyle: "italic"
                  }}
                >
                  {ville}
                </p>
                {citation && citation.length > 0 ? (
                  <h2 className="citation">{citation}</h2>
                ) : (
                  undefined
                )}

                <div>{description}</div>
              </div>
              <div
                className="col4 ateliers wow fadeInDown"
                data-wow-delay="0.3s"
              >
                <h2 className="sous_titre">
                  <strong>Découvrez mes ateliers</strong> du moment
                </h2>
                <ul className="list_ateliers">
                  {!this.props.categories ||
                  this.props.categories.length === 0 ||
                  !this.props.atlList ||
                  this.props.atlList.length === 0 ? (
                    <div>
                      <Spinner />
                    </div>
                  ) : (
                    this.props.atlList
                      .filter(data => this.checkDate(data.acf.ateliers_date))
                      .map(a => (
                        <MesAteliers
                          key={a.id}
                          id={a.id}
                          title={a.title.rendered}
                          cat={a.categories[0]}
                          date={a.acf.ateliers_date}
                          hdebut={a.acf.ateliers_heure_debut}
                          hfin={a.acf.ateliers_heure_fin}
                          ville={a.acf.ateliers_localisation}
                          fillModal={this.props.fillModal}
                          data={a}
                          categories={this.props.categories}
                        />
                      ))
                  )}
                </ul>
              </div>
            </article>
          </section>
          <section className="ambassadrice_ateliers_cat wow fadeInUp">
            {!this.props.categories ||
            this.props.categories.length === 0 ||
            !this.props.atlList ||
            this.props.atlList.length === 0 ? (
              <div>
                <Spinner />
              </div>
            ) : (
              this.props.categories.map(cat => (
                <div
                  key={cat.id}
                  className={
                    "atelier_cat " +
                    cat.acf.selectionner_une_couleur +
                    (atlDispos
                      ? atlDispos
                          .filter(atl => atl.toString() === cat.id.toString())
                          .map(() => " dispo ")
                          .join("")
                      : " pasdispo ")
                  }
                >
                  <a
                    className={"btn " + cat.acf.selectionner_une_couleur}
                    // href="http://monmomentmagique.jeromeb.quai13.com/category/ateliers/minis/"
                    alt=""
                  >
                    {cat.name}
                  </a>
                  <p className="cat_desc">{cat.description}</p>
                </div>
              ))
            )}
          </section>
        </div>
      );
    }
  }
}

export default AmbassadriceContent;

class MesAteliers extends Component {
  state = {};
  render() {
    const catAtelier = this.props.categories
      .filter(cat => cat.id === this.props.data.categories[0])
      .map(cat => cat.name);

    const catColor = this.props.categories
      .filter(cat => cat.id === this.props.data.categories[0])
      .map(cat => cat.acf.selectionner_une_couleur);

    let date = new moment(this.props.date, "M-D-YYYY");
    date = date.format("dddd D MMMM");

    return (
      <li
        className={
          "item " + (this.props.data.acf.ateliers_complet ? "complet" : null)
        }
      >
        <a
          //href={"/les-ateliers/?id=" + this.props.id}
          href={"#detail_atelier"}
          className="lien"
          onClick={() => this.props.fillModal(this.props.data)}
        >
          <h3
            className={catColor}
            dangerouslySetInnerHTML={{
              __html: `<span class="ateliers_cat btn  ${catColor}">${catAtelier}</span>${
                this.props.title
              }`
            }}
          >
            {/* <span className={"ateliers_cat btn " + catColor}>{catAtelier}</span> */}
            {/* {this.props.title} */}
          </h3>
          <div>
            <p className="date">
              {date}
              <span> | </span>
              {this.props.hdebut}-{this.props.hfin}
            </p>
            <p className="localisation">{this.props.ville}</p>
          </div>
        </a>
        {this.props.data.acf.ateliers_complet ? <p>complet</p> : null}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AmbassadriceContent.jsx